<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Complaint Management" title="Completed Services" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort mb-3">
								<div class="row">
									<div class="col-md-4 d-flex align-items-end gap-3 mt-2">
										<div>
											<label class="control-label d-block">Total Complaints:</label>
											<span class="badge rounded-pill bg-primary fs-6">{{ total }}</span>
										</div>
										<button type="button" class="btn btn-success" @click="downloadCompletedLogsExcel()" :disabled="!start_date || !end_date || excel_loading">
											{{ excel_loading ? 'Exporting...' : 'Export Excel' }}
										</button>
									</div>
									<div class="col-md-3 mt-2">
										<label class="control-label">Start Date:</label>
										<input class="form-control" type="date" v-model="start_date" :max="max" value-as-string @change="fetchCompletedLogs()">
									</div>
									<div class="col-md-3 mt-2">
										<label class="control-label">End Date:</label>
										<input class="form-control" type="date" v-model="end_date" :max="max" value-as-string @change="fetchCompletedLogs()">
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-7 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="fetchCompletedLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
												<option value="50">50</option>
												<option value="100">100</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-3 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search IMEI or Vehicle No" v-model="keyword" @keyup="fetchCompletedLogs()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>IMEI</th>
											<th>Dealer</th>
											<th>Vehicle No</th>
											<th>Complaint Type</th>
											<th>Details</th>
											<th>Created Date</th>
											<th>Completed Date</th>
                                            <th>Status</th>
											<th>Payment Status</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(services.length)">
										<tr align="center" v-for="(service,index) in services" :key="service.id">
                                            <td>{{index + 1}}</td>
											<td>
												<b>IMEI:-</b>{{ service.imei }} <br> 
												<b>ICCID:-</b>{{ service.iccid }} <br>
												<b>SIM Provider:-</b>{{ service.sim_provider || '-' }}<br>
											</td>
											<td>{{ formatDealerName(service) }}</td>
											<td>{{service.vehicle_no}}</td>
											<td><b>{{service.service_type == 1 ? 'SIM Change' : service.service_type == 2 ? 'Repair' : service.service_type == 3 ? 'Replacement' : service.service_type == 4 ? 'No Data' : service.service_type == 5 ? 'Tracking Issue' : service.service_type == 6 ? 'Hardware Issue' : service.service_type == 7 ? 'Software Issue' : service.service_type == 8 ? 'Alert Fail' : service.service_type == 9 ? 'Other' : service.service_type == 10 ? 'Renewal Replacement' : 'N/A'}}</b>
												<span v-if="service.work_type !== null"> 
                                                    <span class="badge rounded-pill bg-primary" v-if="service.work_type==1">On Field</span>
                                                    <span class="badge rounded-pill bg-secondary" v-if="service.work_type==2">At Office</span>
                                                </span>
											</td>
											<td>{{ service.details }}</td>
											<td>{{$filters.formatDate(service.created_date)}}</td>
											<td>{{$filters.formatDate(service.completed_date)}}</td>
											<td>
												<span class="badge rounded-pill bg-warning" v-if="service.status == 1">Pending</span>
												<span class="badge rounded-pill bg-info" v-if="service.status == 2">Ongoing</span>
												<span class="badge rounded-pill bg-success" v-if="service.status == 3">Completed</span>
												<span class="badge rounded-pill bg-info" v-if="service.status == 4">Assigned to vendor</span>
												<span class="badge rounded-pill bg-info" v-if="service.status == 5">Component Replacement</span>
												<span class="badge rounded-pill bg-info" v-if="service.status == 6">SIM Change</span>
												<span class="badge rounded-pill bg-secondary" v-if="service.status == 7">Device Replaced</span>

												<span v-if="service.remarks">
													<br><b>Remarks:</b> {{ service.remarks }}
												</span>
											</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="service.payment_status == 1">Payment Received</span>
												<span class="badge rounded-pill bg-danger" v-if="service.payment_status == 2">Payment Pending</span>
												<span class="badge rounded-pill bg-warning" v-if="service.payment_status == 3">Partial Payment</span>
												<span class="badge rounded-pill bg-info" v-if="service.payment_status == 4">Free Service</span>
												<span class="badge rounded-pill bg-secondary" v-if="service.payment_status == 5">Advance</span>
											</td>
                                            <td>
												<router-link :to="{ name: 'solved_complaint_details',params:{id: service.id} }" class="btn btn-primary btn-sm me-2">Details</router-link>
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="12" align="center">No data available in the table</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(services.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchCompletedLogs(page.url + '&limit=' + listing_length + '&keyword=' + keyword + '&from_date=' + start_date + '&to_date=' + end_date)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Technician<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="technician">
								<option value="">--Select--</option>
								<option value="1">Technician 1</option>
								<option value="2">Technician 2</option>
							</select>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" @click="closeModal()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>


	</div>
</template>

<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Pincode Page",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {
			return {
				
				modal_title: "Assign Technician",
				button_title: "Save",

				keyword: "",
				showsearch: false,
				listing_length: 10,
				token: "",
				errors: {},

                button_title: "Save",
                name: "",
				technician: "",

				services:[],

				start_date: '',
				end_date: new Date().toISOString().slice(0, 10),
				max: new Date().toISOString().slice(0, 10),
				total: 0,
				excel_loading: false,
			};
		},
		created() {
			this.fetchCompletedLogs();
		},
		methods: {

			formatDealerName(service) {
				const dealerName = service?.dealer_name;
				if (dealerName != null && String(dealerName).trim() !== '') {
					return dealerName;
				}
				const parts = [service?.dealer_first_name, service?.dealer_last_name].filter(Boolean);
				return parts.join(' ') || '-';
			},

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchCompletedLogs(page_url = null) {
				this.getToken();
				let url = "/staffs/completedLogs?limit=" + this.listing_length  +  "&keyword=" + this.keyword + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.services = responseData.services.data;
						this.pagination = responseData.services.links;
						this.from = responseData.services.from;
						this.to = responseData.services.to;
						this.total = responseData.services.total;
						
					})
					.catch((err) => console.log(err));
			},

			downloadCompletedLogsExcel() {
				if (!this.start_date || !this.end_date) return;

				this.getToken();
				const params = new URLSearchParams({
					keyword: String(this.keyword || "").trim(),
					status: this.status || "",
					from_date: this.start_date,
					to_date: this.end_date,
				});
				this.excel_loading = true;
				this.$axios
					.get("/staffs/completedLogsExcel?" + params.toString(), { headers: { Authorization: "Bearer " + this.token }, responseType: "blob" })
					.then((response) => {
						const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
						const link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "solved_complaints_" + this.start_date + "_" + this.end_date + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(link.href);
					})
					.catch((err) => console.log(err))
					.finally(() => {
						this.excel_loading = false;
					});
			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},

            assignTechnician() {
                this.errors = {};
                this.technician = "";
				this.modal_title = "Assign Technician";
				this.button_title = "Save";
				this.showModal();
            },
			
		},
	};
</script>